import { evaluateResponseErrorCode, getApiError } from '../../errors';
import { post } from '../../http';

export type ChangePasswordRequest = {
  oldPassword: string;
  newPassword: string;
};
export const requestChangePassword = async ({ ...requestBody }: ChangePasswordRequest) => {
  try {
    const result = await post('/guest/profilePasswordUpdate', {
      body: JSON.stringify(requestBody),
    });

    evaluateResponseErrorCode(result.response);

    return result.response;
  } catch (error) {
    throw getApiError(error);
  }
};
